import { render, staticRenderFns } from "./IPGSettlementSettings.vue?vue&type=template&id=03bb937f&scoped=true&"
import script from "./IPGSettlementSettings.vue?vue&type=script&lang=js&"
export * from "./IPGSettlementSettings.vue?vue&type=script&lang=js&"
import style0 from "./IPGSettlementSettings.vue?vue&type=style&index=0&id=03bb937f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb937f",
  null
  
)

export default component.exports